<template>
    <!--<div class="footer">
        <div class="content" v-html="footer_copy"></div>
    </div>-->
    <van-tabbar route safe-area-inset-bottom>
        <van-tabbar-item replace to="/home" icon="home-o">首页</van-tabbar-item>
        <van-tabbar-item replace to="/report" icon="search">报告查询</van-tabbar-item>
        <van-tabbar-item replace to="/personal" icon="user-o">个人中心</van-tabbar-item>
    </van-tabbar>
</template>
<script>
    import {Tabbar, TabbarItem} from 'vant';

    export default {
        components: {[Tabbar.name]: Tabbar, [TabbarItem.name]: TabbarItem},
        data() {
            return {
                //footer_copy: "<p>版权所有 © 2019 --------------</p><p><a class='abq' href='http://www.beian.miit.gov.cn' target='_blank'>***************</a></p>"
            }
        }
    }
</script>
<style lang="scss" scoped></style>
